import { useState } from 'react';

export const useLightbox = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openLightbox = (imageArray, index = 0) => {
    setImages(imageArray);
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const closeLightbox = () => {
    setIsOpen(false);
    setTimeout(() => {
      setImages([]);
      setCurrentIndex(0);
    }, 300);
  };

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const previousImage = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return {
    isOpen,
    images,
    currentIndex,
    openLightbox,
    closeLightbox,
    nextImage,
    previousImage,
  };
};
